import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { User } from "@/shared-module/models";
import { Userpilot } from "userpilot";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  currentUser: User;
  static userPilotInitialized: boolean = false;

  constructor(private http: HttpClient) {
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
  }

  public get currentUserValue(): User {
    if (
      this.currentUser != null &&
      !AuthenticationService.userPilotInitialized
    ) {
      Userpilot.identify(this.currentUser.userName, {
        name: this.currentUser.userName,
        locale_code: this.currentUser.language /*,
                email: user.email,
                created_at: user.created_at,*/,
      });
      console.log(
        `UserPilot initialized with username ${this.currentUser.userName}`,
      );
      AuthenticationService.userPilotInitialized = true;
    }

    return this.currentUser;
  }

  login(username, password) {
    return this.http.post<User>("api/login", { username, password }).pipe(
      map((reply) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (reply.isSuccess) {
          localStorage.setItem("currentUser", JSON.stringify(reply));
          this.currentUser = reply;
        }
        return reply;
      }),
    );
  }

  connect(idToken) {
    return this.http.post<User>("api/login", { idToken }).pipe(
      map((reply) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if (reply.isSuccess) {
          localStorage.setItem("currentUser", JSON.stringify(reply));
          this.currentUser = reply;
        }
        return reply;
      }),
    );
  }

  logout() {
    // remove user from local storage and set current user to null
    localStorage.removeItem("currentUser");
    this.currentUser = null;
    AuthenticationService.userPilotInitialized = false;
  }
}
